export type Random = () => number;

export const between = (random: Random, low: number, high: number) => low + random() * (high - low);
export const clamp01 = (value: number) => Math.min(1, Math.max(0, value));
export const smooth = (value: number) => { const t = clamp01(value); return t * t * (3 - 2 * t); };
/** A smooth 0 → 1 → 0 bump over `[start, start + length]` of a repeating cycle. */
export const pulse = (cycle: number, start: number, length: number) => { const t = (cycle - start) / length; return t <= 0 || t >= 1 ? 0 : Math.sin(Math.PI * t) ** 2; };
export const fract = (value: number) => value - Math.floor(value);
export const wrapAngle = (angle: number) => Math.atan2(Math.sin(angle), Math.cos(angle));
/** Turns `current` toward `target` by at most `step` radians along the short way. */
export const turnToward = (current: number, target: number, step: number) => {
  const difference = wrapAngle(target - current);
  return Math.abs(difference) <= step ? target : current + Math.sign(difference) * step;
};
/** Heading of a ground vector, `0` facing +Z as every figure does. */
export const headingOf = (dx: number, dz: number) => Math.atan2(dx, dz);

/** What a ground critter can ask of the world it lives in. */
export interface CritterWorld {
  free(x: number, z: number, margin: number): boolean;
  /** The nearest thing worth fleeing from within `reach` metres, if any. */
  threat(x: number, z: number, reach: number): { x: number; z: number; distance: number } | null;
}
